document.addEventListener('DOMContentLoaded', () => {
  const tabletMediaQuery = window.matchMedia('(max-width: 1239px)');
  const founderStorySwiper = document.querySelector('.card-carousel');

  if (
    founderStorySwiper !== null &&
    founderStorySwiper.classList.contains('swiper-container-initialized')
  ) {
    tabletMediaQuery.addEventListener('change', () => {
      founderStorySwiper.swiper.update();
    });
  }
});
